module.exports = __webpack_public_path__ + "img/1.da01f902.jpg";